/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { access_token_token } from '../models/access_token_token';
import type { CarResource } from '../models/CarResource';
import type { cluster_public_http_api_url } from '../models/cluster_public_http_api_url';
import type { contract_id } from '../models/contract_id';
import type { event_id } from '../models/event_id';
import type { EventResource } from '../models/EventResource';
import type { latitude } from '../models/latitude';
import type { limit } from '../models/limit';
import type { longitude } from '../models/longitude';
import type { offset } from '../models/offset';
import type { ressourceType } from '../models/ressourceType';
import type { sortOder } from '../models/sortOder';
import type { vod_duration_seconds } from '../models/vod_duration_seconds';
import type { vod_has_bus_can } from '../models/vod_has_bus_can';
import type { vod_id } from '../models/vod_id';
import type { vod_name } from '../models/vod_name';
import type { vod_published } from '../models/vod_published';
import type { vod_thumbnail_base64 } from '../models/vod_thumbnail_base64';
import type { vod_thumbnail_mime_type } from '../models/vod_thumbnail_mime_type';
import type { VodMergeCandidates } from '../models/VodMergeCandidates';
import type { VodMergePart } from '../models/VodMergePart';
import type { VodOrigin } from '../models/VodOrigin';
import type { VodReadAccess } from '../models/VodReadAccess';
import type { vodStatus } from '../models/vodStatus';
import type { vodType } from '../models/vodType';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class VodService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * @returns any VOD Created
     * @throws ApiError
     */
    public vodControllerPostVod({
        requestBody,
    }: {
        requestBody: {
            name?: string | null;
            type: vodType;
            event_id?: event_id;
            latitude?: latitude;
            longitude?: longitude;
            car_id?: number | null;
        },
    }): CancelablePromise<{
        ressource_type: ressourceType;
        ressource_id: number;
        cluster_http_api_url: cluster_public_http_api_url;
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/VOD',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Wrong syntax.`,
                404: `Service not found.`,
                500: `Internal error.`,
            },
        });
    }
    /**
     * @returns any VODs list
     * @throws ApiError
     */
    public vodControllerGetVoDs({
        folderId,
        offset,
        limit,
        sort,
        nameLike,
        id,
        status,
        hasBusCan,
        minDate,
        maxDate,
        contentAvailable,
        eventId,
        contractId,
        carId,
        search,
        applicationDeviceId,
        includeMerged,
    }: {
        /**
         * Filter by an authenticated user-owned folder.
         */
        folderId?: number,
        offset?: offset,
        limit?: limit,
        /**
         * Sort criteria. properties to sort on with 'ASC' or 'DESC' as value.
         */
        sort?: {
            created_at?: sortOder;
            name?: sortOder;
        },
        /**
         * Filter VODs on name containing a specific value.
         */
        nameLike?: string,
        /**
         * Filter VODs on their exact id.
         */
        id?: vod_id,
        /**
         * Filter VODs on their status.
         */
        status?: vodStatus,
        /**
         * Filter VODs by BUS CAN data availability.
         */
        hasBusCan?: boolean,
        /**
         * Filter VODs with their display date greater than or equal to this UTC datetime (inclusive).
         */
        minDate?: string,
        /**
         * Filter VODs with their display date lower than or equal to this UTC datetime (inclusive).
         */
        maxDate?: string,
        /**
         * Only return VODs containing at least one video chunk or BUS CAN segment.
         */
        contentAvailable?: boolean,
        /**
         * Filter VODs on event_id.
         */
        eventId?: event_id,
        /**
         * Filter VODs on contract_id.
         */
        contractId?: contract_id,
        carId?: number,
        /**
         * Case-insensitive substring match on VOD name or associated event name.
         */
        search?: string,
        /**
         * Filter VODs recorded by this application device.
         */
        applicationDeviceId?: number,
        /**
         * Also list VODs merged into another VOD. By default only standalone and master VODs are listed; a master already spans its parts.
         */
        includeMerged?: boolean,
    }): CancelablePromise<{
        items: Array<{
            folder_ids?: Array<number>;
            id: vod_id;
            name: vod_name;
            contract_id: contract_id;
            type: vodType;
            status: vodStatus;
            published: vod_published;
            has_bus_can: vod_has_bus_can;
            created_at: string;
            first_chunk_live_start_datetime_utc: string | null;
            duration_seconds: vod_duration_seconds;
            thumbnail: vod_thumbnail_base64;
            thumbnail_mime_type: vod_thumbnail_mime_type;
            event_id: event_id | null;
            event: EventResource | null;
            car_id?: number | null;
            car?: CarResource | null;
            origin?: VodOrigin;
            /**
             * Master VOD serving this VOD as one of its parts.
             */
            merged_into_vod_id?: number | null;
            /**
             * Parts served after this master VOD, in order. Empty for a standalone VOD.
             */
            merge_parts?: Array<VodMergePart>;
        }>;
        total: number;
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/VOD',
            query: {
                'folder_id': folderId,
                'offset': offset,
                'limit': limit,
                'sort': sort,
                'name_like': nameLike,
                'id': id,
                'status': status,
                'has_bus_can': hasBusCan,
                'min_date': minDate,
                'max_date': maxDate,
                'content_available': contentAvailable,
                'event_id': eventId,
                'contract_id': contractId,
                'car_id': carId,
                'search': search,
                'application_device_id': applicationDeviceId,
                'include_merged': includeMerged,
            },
        });
    }
    /**
     * @returns any VOD informations.
     * @throws ApiError
     */
    public vodControllerGetVodInfos({
        id,
    }: {
        /**
         * Id of the VOD to get infos for
         */
        id: vod_id,
    }): CancelablePromise<{
        read_access?: VodReadAccess;
        id: vod_id;
        name: vod_name;
        status: vodStatus;
        has_bus_can: vod_has_bus_can;
        created_at: string;
        first_chunk_live_start_datetime_utc: string | null;
        duration_seconds: vod_duration_seconds;
        thumbnail: vod_thumbnail_base64;
        thumbnail_mime_type: vod_thumbnail_mime_type;
        event_id: event_id | null;
        event: EventResource | null;
        car_id?: number | null;
        car?: CarResource | null;
        origin?: VodOrigin;
        /**
         * Master VOD serving this VOD as one of its parts.
         */
        merged_into_vod_id?: number | null;
        /**
         * Parts served after this master VOD, in order. Empty for a standalone VOD.
         */
        merge_parts?: Array<VodMergePart>;
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/VOD/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Wrong syntax.`,
                401: `Unauthorized.`,
                404: `Not found.`,
                500: `Internal error.`,
            },
        });
    }
    /**
     * @returns void
     * @throws ApiError
     */
    public vodControllerDeleteVod({
        id,
    }: {
        /**
         * Id of the VOD to delete
         */
        id: vod_id,
    }): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/VOD/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Wrong syntax.`,
                401: `Unauthorized.`,
                404: `Not found.`,
                500: `Internal error.`,
            },
        });
    }
    /**
     * @returns void
     * @throws ApiError
     */
    public vodControllerCloseVod({
        id,
    }: {
        /**
         * Id of the VOD to close (makes VOD not live anymore)
         */
        id: vod_id,
    }): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/VOD/{id}/close',
            path: {
                'id': id,
            },
            errors: {
                400: `Wrong syntax.`,
                401: `Unauthorized.`,
                404: `Not found.`,
                500: `Internal error.`,
            },
        });
    }
    /**
     * @returns any VOD renamed
     * @throws ApiError
     */
    public vodControllerRenameVod({
        id,
        requestBody,
    }: {
        /**
         * Id of the VOD to rename
         */
        id: vod_id,
        requestBody: {
            name: string | null;
        },
    }): CancelablePromise<{
        id: vod_id;
        name: string | null;
    }> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/VOD/{id}/name',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Wrong syntax.`,
                401: `Unauthorized.`,
                404: `Not found.`,
                500: `Internal error.`,
            },
        });
    }
    /**
     * @returns any VOD event association updated.
     * @throws ApiError
     */
    public vodControllerPutEvent({
        id,
        requestBody,
    }: {
        id: vod_id,
        requestBody: {
            /**
             * Existing event ID, or null to remove the association.
             */
            event_id: number | null;
        },
    }): CancelablePromise<{
        id: vod_id;
        event_id: number | null;
    }> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/VOD/{id}/event',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid request or event from another contract.`,
                401: `Unauthorized.`,
                404: `VOD or event not found.`,
                500: `Internal error.`,
            },
        });
    }
    /**
     * Current parts of a master VOD and the VODs that can still be appended: recorded by the same application device, on the same contract and cluster, uploaded, each one starting less than one hour after the end of the previous one.
     * @returns VodMergeCandidates Merge state of the VOD.
     * @throws ApiError
     */
    public vodControllerGetMergeCandidates({
        id,
    }: {
        id: vod_id,
    }): CancelablePromise<VodMergeCandidates> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/VOD/{id}/merge_candidates',
            path: {
                'id': id,
            },
            errors: {
                400: `Wrong syntax.`,
                401: `Unauthorized.`,
                404: `Not found.`,
                500: `Internal error.`,
            },
        });
    }
    /**
     * Sets the ordered parts served after a master VOD as a single VOD (playlist, Bus CAN, laps, alerts). The parts keep their own data and can be separated again with an empty list. The list must start with the current parts or the merge candidates, without skipping any.
     * @returns VodMergeCandidates Parts updated.
     * @throws ApiError
     */
    public vodControllerPutParts({
        id,
        requestBody,
    }: {
        id: vod_id,
        requestBody: {
            vod_ids: Array<vod_id>;
        },
    }): CancelablePromise<VodMergeCandidates> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/VOD/{id}/parts',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Wrong syntax.`,
                401: `Unauthorized.`,
                404: `Not found.`,
                409: `A VOD cannot be merged (other device, gap over one hour, not uploaded, already merged elsewhere).`,
                500: `Internal error.`,
            },
        });
    }
    /**
     * @returns VodReadAccess Download informations.
     * @throws ApiError
     */
    public vodControllerGetVodReadAccess({
        id,
    }: {
        /**
         * Id of the VOD to get the download link for
         */
        id: vod_id,
    }): CancelablePromise<VodReadAccess> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/VOD/{id}/read_access',
            path: {
                'id': id,
            },
            errors: {
                400: `Wrong syntax.`,
                401: `Unauthorized.`,
                404: `Not found.`,
                500: `Internal error.`,
            },
        });
    }
    /**
     * @returns any Download informations.
     * @throws ApiError
     */
    public vodControllerGetVodUploadLink({
        id,
    }: {
        /**
         * Id of the VOD to get the upload link for
         */
        id: vod_id,
    }): CancelablePromise<{
        access_token: access_token_token;
        cluster_base_url: string;
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/VOD/{id}/upload_link',
            path: {
                'id': id,
            },
            errors: {
                400: `Wrong syntax.`,
                401: `Unauthorized.`,
                404: `Not found.`,
                500: `Internal error.`,
            },
        });
    }
}
